import {
 Menu, ArrowLeft
} from 'lucide-react';
import {
 Button
} from 'shared/components/ui/button';
import {
 useLocation, useNavigate
} from 'react-router-dom';

// Define the types for props
interface TableHeaderProps {
    onMenuClick: () => void; // The function that will be triggered on menu button click
}

export function TableHeader({
 onMenuClick
}: TableHeaderProps) {
    const location = useLocation();
    const navigate = useNavigate();

    // Function to handle the back button click and navigate to the 'manage-app' page
    const handleBackClick = () => {
        const currentPath = location.pathname;
        const newPath = currentPath.replace(/\/data-builder\/tables.*$/, '/manage-app');
        navigate(newPath);
    };

    return (
        <header className="flex h-14 items-center justify-between border-b bg-background px-6">
            <div className="flex items-center gap-4">
                <Button variant="ghost" size="icon" onClick={handleBackClick} className="h-8 w-8">
                    <ArrowLeft className="h-5 w-5" />
                </Button>
                <Button variant="ghost" size="icon" onClick={onMenuClick} className="h-8 w-8">
                    <Menu className="h-5 w-5" />
                </Button>
            </div>
            <div className="flex-1 max-w-md px-4">
                {/* Additional content can go here */}
            </div>
        </header>
    );
}
